__turbopack_context__.v({
  "base": "button-module-scss-module__Z2k9va__base",
  "disabled": "button-module-scss-module__Z2k9va__disabled",
  "loading": "button-module-scss-module__Z2k9va__loading",
  "primary": "button-module-scss-module__Z2k9va__primary",
  "secondary": "button-module-scss-module__Z2k9va__secondary",
});
